import {IRegexHelper} from "./regexTypes";

// URL validation pattern
// Matches URLs with or without protocol (http://, https://)
// Requires at least one dot in the domain
// Examples: example.com, www.example.com, http://example.com, https://www.example.com, subdomain.example.com
export const UrlRegex: IRegexHelper = {
  pattern: /^(https?:\/\/)?(www\.)?([\da-z]([\da-z-]*[\da-z])?\.)+[a-z]{2,}(\/.*)?$/i,
  error: "Invalid website URL. Must contain a domain with at least one dot (e.g., example.com)",
}
